import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { uniqueId } from 'lodash/fp';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';

import { RainfallIcon } from '../../../../assets/svg/Icon';

import { styles, StyledBadge } from '../../style';

const useStyles = makeStyles(styles);
const initPath = `/${process.env.REACT_APP_PATH}`;

export default function RainfallForecastList(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    datas, currentMode, currentAreaCode, handleOpenLegend, mobilemode,
  } = props;

  let datasFilter = datas;
  if (currentMode === 'province' && currentAreaCode > 0) {
    datasFilter = datas.filter((d) => d.province_code === currentAreaCode);
  }

  const renderList = (dataList) => (
    <>
      {dataList.map((row) => {
        const boxClass = (row.rainforecast_level === 4) ? classes.yellow : classes.red;
        return (
          <Grid item key={uniqueId()}>
            <Box className={`${classes.listsBox} ${boxClass}`}>
              {row.province_name.th}
            </Box>
          </Grid>
        );
      })}
    </>
  );

  const countList = datasFilter.length;

  return (
    <>
      <Box className={mobilemode ? classes.boxViewMobile : classes.boxViewForecastRainfall}>
        <Box display="flex" justifyContent="flex-end">
          <Box>
            <Box display="flex" alignItems="center">
              <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                <StyledBadge
                  id="main-forecast-rain-click"
                  badgeContent={countList}
                  overlap="circular"
                  color="secondary"
                >
                  <RainfallIcon style={{ color: 'white' }} />
                </StyledBadge>
              </Box>
              <Box display="flex" alignItems="center">
                <Box pl={1}>
                  <IconButton id="legend-forecast-rain" className={classes.btn} onClick={handleOpenLegend(t('เกณฑ์คาดการณ์ฝน'), 'RainfallForecast')}>
                    <InfoIcon type="button" style={{ fontSize: 13, color: '#777' }} />
                  </IconButton>
                </Box>
                <Box p={1}>
                  <NavLink id="navigate_rainfallforecast" to={`${initPath}forecast/rainfall`} activeClassName="nav-active">
                    <Typography className={classes.titleBox}>{t('คาดการณ์ฝน')}</Typography>
                  </NavLink>
                </Box>
                <Box><Typography className={classes.timeBox}>{datas.time}</Typography></Box>
              </Box>
            </Box>
            <Box>
              <Grid id="dialog_rainfallforecast_list_provinces" container justifyContent="flex-start" spacing={1} className={classes.contentBox}>
                <>
                  {(countList <= 0)
                    ? (
                      <Grid item>
                        <Box
                          className={`${classes.listsBox}`}
                          style={{ backgroundColor: '#FFFFFF90', fontWeight: 'bold' }}
                        >
                          {t('ปกติ')}
                        </Box>
                      </Grid>

                    ) : renderList(datasFilter)}
                </>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

RainfallForecastList.defaultProps = {
  currentMode: '',
  currentAreaCode: '',
  mobilemode: false,
};

RainfallForecastList.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  currentMode: PropTypes.string,
  currentAreaCode: PropTypes.string,
  handleOpenLegend: PropTypes.func.isRequired,
  mobilemode: PropTypes.bool,
};
